module.exports = __webpack_public_path__ + "media/site_templates/www.guttercleaning.biz/images/about_us-2e4680883030c10a4dc606c4a1d986c5.jpg";